import React from "react";
import "./Cruise_Policies.css";
import Common_Title from "../../../common_component/common_title/Common_Title";

function Cruises_Policies({ data }) {
  return (
    <section className="cruise_policies_section">
      <div className="container">
        {/* Confirmation Policy */}
        <div className="policy_block">
          <Common_Title title="Confirmation policy" />

          <ul>
            <div
              className="confirmation_policy"
              dangerouslySetInnerHTML={{ __html: data?.confirmation_policy }}
            />
          </ul>
        </div>

        <div className="policy_block">
          <Common_Title title="Refund Policy" />

          <ul>
            <div
              className="refund_policy"
              dangerouslySetInnerHTML={{ __html: data?.refund_policy }}
            />
          </ul>
        </div>

        <div className="policy_block">
          <Common_Title title="Cancellation Policy" />

          <ul>
            <div
              className="confirmation_policy"
              dangerouslySetInnerHTML={{ __html: data?.confirmation_policy }}
            />
          </ul>
        </div>

        <div className="policy_block">
          <Common_Title title="Payment Policy" />
          <ul>
            <div
              className="confirmation_policy"
              dangerouslySetInnerHTML={{ __html: data?.confirmation_policy }}
            />
          </ul>
        </div>
      </div>
    </section>
  );
}

export default Cruises_Policies;
